import { render, staticRenderFns } from "./cup-overview.vue?vue&type=template&id=75b0cffa&"
import script from "./cup-overview.ts?vue&type=script&lang=ts&"
export * from "./cup-overview.ts?vue&type=script&lang=ts&"
import style0 from "./cup-overview.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFooter,VTextField})
